import PropTypes from 'prop-types';
import { Icon, USER_INTERFACE_ARROW_04_RIGHT, LoadBlock } from '@bwoty-web/styleguide';

import styles from './OfferRow.scss';

export const OfferRow = (props) => {
  const { href, price, label, info, isLoading } = props;

  if (isLoading) {
    return (
      <div className={styles.root}>
        <div className={styles.label}>
          <LoadBlock style={{ width: 80, height: 16 }} />
        </div>
        <div className={styles.priceContainer}>
          <div className={styles.price}>
            <LoadBlock style={{ width: 90, height: 20 }} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <a className={styles.root} href={href} rel="nofollow">
      <div className={styles.label}>
        <strong className={styles.header}>{label}</strong>
        {info ? <span className={styles.info}>({info})</span> : null}
      </div>
      <div className={styles.priceContainer}>
        <div className={styles.price}>{price}</div>
      </div>
      <Icon
        path={USER_INTERFACE_ARROW_04_RIGHT}
        size="xs"
        sizeMobile="xxs"
        className={styles.arrow}
      />
    </a>
  );
};

OfferRow.propTypes = {
  href: PropTypes.string,
  price: PropTypes.node,
  label: PropTypes.node,
  info: PropTypes.node,
  isLoading: PropTypes.bool,
};
